import React from 'react'
import { Box, Tabs } from '@mui/material';
import { Outlet } from 'react-router-dom';
import {
  useLocation,
} from "react-router-dom";
import LinkTab from '../../components/common/tabs/LinkTab';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const NavBarItem = {
  '/inventorymng': 0,
  '/inventorymng/history': 1,
}

const InventoryMngPage = () => {
  let location = useLocation();
  const [value, setValue] = React.useState(NavBarItem[location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <BreadcrumbsContainer title="제품관리/재고 관리/재고 내역" icon="warehouse" />
      <Box sx={{ width: '100%', mt: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
            <LinkTab label="재고 관리" to={`/inventorymng`} />
            <LinkTab label="재고 이력" to={`/inventorymng/history`} />
          </Tabs>
        </Box>
      </Box>

      <Outlet />
    </Box>

  )
}

export default InventoryMngPage
